import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { NgxSpinnerModule } from 'ngx-spinner';

import { CartaPorteRoutingModule } from './carta-porte-routing.module';
import { CartaPorteCreateComponent } from 'src/app/carta-porte/carta-porte-create/carta-porte-create.component';
import { CartaPorteListComponent } from 'src/app/carta-porte/carta-porte-list/carta-porte-list.component';
import { CartaPorteAddComponent } from 'src/app/carta-porte/carta-porte-add/carta-porte-add.component';
import { CartaPorteEditComponent } from 'src/app/carta-porte/carta-porte-edit/carta-porte-edit.component';
import { CartaPorteActionsComponent } from 'src/app/carta-porte/carta-porte-actions/carta-porte-actions.component';
import { CartaPorteViewComponent } from 'src/app/carta-porte/carta-porte-view/carta-porte-view.component';

@NgModule({
  declarations: [
    CartaPorteCreateComponent,
    CartaPorteListComponent,
    CartaPorteAddComponent,
    CartaPorteEditComponent,
    CartaPorteActionsComponent,
    CartaPorteViewComponent
  ],
  imports: [
    CommonModule,
    CartaPorteRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    AgGridModule,
    RouterModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CartaPorteModule { }
